import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import { searchPhoneNumbers as _searchPhoneNumbers } from '../es6/legacy/findPhoneNumbers.js'

export function searchPhoneNumbers() {
	return withMetadataArgument(_searchPhoneNumbers, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/searchPhoneNumbers.js
// module id = 1tzh
// module chunks = 64